const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

export async function getConversations({ limit = 20, coachClientId } = {}) {
  const params = new URLSearchParams();
  if (limit) params.set('limit', limit);
  if (coachClientId) params.set('coachClientId', coachClientId);

  const response = await fetch(`${API_URL}/ai-coach/conversations?${params}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error('Failed to load conversations');
  return response.json();
}

export async function getConversation(id) {
  const response = await fetch(`${API_URL}/ai-coach/conversations/${id}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error('Failed to load conversation');
  return response.json();
}

export async function createConversation({ title, coachClientId } = {}) {
  const response = await fetch(`${API_URL}/ai-coach/conversations`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ title, coachClientId })
  });
  if (!response.ok) throw new Error('Failed to create conversation');
  return response.json();
}

export async function deleteConversation(id) {
  const response = await fetch(`${API_URL}/ai-coach/conversations/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error('Failed to delete conversation');
  return response.json();
}

export async function getUsage() {
  const response = await fetch(`${API_URL}/ai-coach/usage`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error('Failed to get usage');
  return response.json();
}

export async function getRecipeSuggestions(payload) {
  const response = await fetch(`${API_URL}/ai-coach/recipe-suggestions`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload || {})
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Failed to get recipe suggestions');
  }

  return data;
}

/** @deprecated - transport is now configured directly in AIChatPanel */
export function getChatConfig() {
  const token = localStorage.getItem('token');
  return {
    api: `${API_URL}/ai-coach/chat`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
}
